import React, { Component } from "react";

export default class Cover extends Component {
	
	render () {
						    
	    return (
		    					
			<div className="c-cover"></div>
		    
		)
						
	}
}
